import React from 'react';
import { ArrowDownRight, Phone, Star } from 'lucide-react';
import { Button } from './Button';
export function Hero() {
  return <section id="top" className="relative isolate min-h-[660px] overflow-hidden bg-[#123b35] text-white sm:min-h-[720px]" data-id="element-44">
      <img src="https://cdn.magicpatterns.com/uploads/hDKWxRKDHXbeHkkZ4qQxho/Screenshot_2026-07-10_103152.png" alt="Illuminated natural swimming pool and stone terrace at night" className="absolute inset-0 -z-20 h-full w-full object-cover object-center" data-id="element-45" />
      <div className="absolute inset-0 -z-10 bg-[#071b24]/55" aria-hidden="true" data-id="element-46" />

      <div className="mx-auto flex min-h-[660px] max-w-7xl items-end px-5 py-14 sm:min-h-[720px] sm:px-8 sm:py-20" data-id="element-47">
        <div className="max-w-2xl" data-id="element-48">
          <p className="mb-7 flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.2em] text-[#a6edf0] [text-shadow:0_1px_12px_rgba(0,0,0,0.8)]" data-id="element-49">
            <span className="h-px w-8 bg-[#a6edf0]" data-id="element-50" /> Phoenix, Arizona
          </p>
          <h1 className="max-w-xl text-5xl font-medium leading-[0.98] tracking-[-0.055em] [text-shadow:0_3px_20px_rgba(0,0,0,0.75)] sm:text-6xl lg:text-7xl" data-id="element-51">
            A pool that feels like{' '}
            <span className="text-[#a6edf0]" data-id="element-52">your place.</span>
          </h1>
          <p className="mt-7 max-w-lg text-base leading-7 text-[#f2f7f4] [text-shadow:0_2px_12px_rgba(0,0,0,0.85)] sm:text-lg" data-id="element-53">
            Design a backyard that slows life down—from natural, chemical-free
            water to beautifully considered new builds, remodels, and fiberglass
            pools.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-54">
            <Button asChild size="lg" className="h-12 rounded-full bg-[#8de0e5] px-6 text-[#123b35] hover:bg-white" data-id="element-55">
              <a href="#consultation" className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap" data-id="element-56">
                Start your pool project
                <ArrowDownRight size={18} aria-hidden="true" data-id="element-57" />
              </a>
            </Button>
            <Button asChild size="lg" variant="outline" className="h-12 rounded-full border-white/50 bg-[#123b35]/30 px-6 text-white hover:bg-white/15 hover:text-white" data-id="element-58">
              <a href="tel:+16025656313" className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap" data-id="element-59">
                <Phone size={17} aria-hidden="true" data-id="element-60" />
                Talk to our team
              </a>
            </Button>
          </div>

          <div className="mt-11 flex flex-wrap items-center gap-3 text-sm text-[#f2f7f4] [text-shadow:0_1px_10px_rgba(0,0,0,0.8)]" data-id="element-61">
            <span className="flex items-center gap-1 rounded-full border border-white/35 bg-[#123b35]/35 px-3 py-1.5" data-id="element-62">
              <Star size={14} className="fill-[#a6edf0] text-[#a6edf0]" aria-hidden="true" data-id="element-63" />
              4.6 on Google
            </span>
            <span data-id="element-64">Serving the Phoenix area</span>
          </div>
        </div>
      </div>
    </section>;
}